import Image from 'next/image';
import { CDN2 } from '@/helpers/api';
import Link from 'next/link';
import { Button } from 'antd';

export default function LinksSection() {
  return (
    <div className="w-full bg-gray-50">
      <div className="px-4 md:px-32 xl:px-4 mx-auto w-full flex flex-col justify-between items-center max-w-7xl py-16">
        <h2 className="text-xl lg:text-3xl font-bold md:hidden my-6" >Content Creator</h2>
        <div className="flex-1 flex flex-col-reverse md:flex-row items-center w-full md:gap-x-6">
          <div className="flex-1 flex flex-col items-center md:items-start space-y-6">
            <h2 className="text-xl lg:text-3xl font-bold hidden md:block" >Content Creator</h2>
            <p className="text-base md:text-lg text-center md:text-left">
              <strong>Inspire more travel and earn along the way</strong> by <strong>promoting affordable parking</strong>.
              Turn your content into a <strong>steady income stream</strong> with deals that <strong>make trips easier and more affordable</strong>.
            </p>
            <Link href="/creators">
              <Button type="primary">
                Explore Program
              </Button>
            </Link>
          </div>
          <div className="flex-1 flex justify-end">
            <Image
              src={CDN2() + '/staticmyapp/partnerus/Creators.jpg'}
              alt="Creators"
              width="448"
              height="448"
              quality={100}
              className="w-40 md:w-[448px] border rounded-lg h-auto"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
